var map = {
	"./BaseBigimg/index.js": "eb0f",
	"./BaseBigimg/main.vue": "d735",
	"./download/pingjia.vue": "91fd",
	"./download/shiyong.vue": "a58b",
	"./download/tongyong.vue": "d760",
	"./download/vcd.vue": "746e",
	"./download/xuexizliao.vue": "538b",
	"./success/beij.vue": "ad8e",
	"./success/guangz.vue": "e89e",
	"./success/qitadq.vue": "08b6",
	"./success/shangh.vue": "15b3",
	"./success/zhej.vue": "f246",
	"./trade/guonei.vue": "5134",
	"./trade/guoneinew.vue": "8692",
	"./trade/guowai.vue": "25aa",
	"./trade/qiquan.vue": "aba2",
	"./trade/tzjg.vue": "5b95",
	"./wh7/wh7footer.vue": "0f87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9c2";